export const TOKEN_ADICIONAR = 'TOKEN_ADICIONAR'
export const TOKEN_REMOVER = 'TOKEN_REMOVER'
export const TOKEN_VALIDO = 'TOKEN_VALIDO'
